import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { EditLicensingOptionsMenuController } from '../controller/EditLicensingOptionsMenuController';
import { CompanyData } from '../../../types/company-data';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { CompanyType } from '../../../types/company-type';
import { CompanyLicenseInformation } from '../../../../license/types/CompanyLicenseInformation';

export class EditLicensingOptionsMenuWebComponent extends BaseWebComponentElement {
  public controller!: EditLicensingOptionsMenuController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EditLicensingOptionsMenuController,
    });
  }

  public set company(companyData: CompanyData | null) {
    if (!companyData) {
      this.removeAttribute('data-company');
    }

    this.setAttribute('data-company', JSON.stringify(companyData));
  }

  public get company(): CompanyData | null {
    const companyDataString = this.getAttribute('data-company');

    if (!companyDataString) {
      return null;
    }

    return JSON.parse(companyDataString);
  }

  public set context(newContext: CompanyActionContext) {
    this.setAttribute('context', newContext);
  }

  public get context(): CompanyActionContext {
    const context = this.getAttribute('context');

    if (!CompanyActionContext.isValid(context)) {
      throw new Error(`CompanyActionContext context not valid: ${context}`);
    }

    return context as CompanyActionContext;
  }

  public set companyLicenseInformation(companyLicenseInformation: CompanyLicenseInformation | null) {
    if (!companyLicenseInformation) {
      this.removeAttribute('data-license-info');
    }

    this.setAttribute('data-license-info', JSON.stringify(companyLicenseInformation));
  }

  public get companyLicenseInformation(): CompanyLicenseInformation | null {
    const companyLicenseInformation = this.getAttribute('data-license-info');

    if (!companyLicenseInformation) {
      return null;
    }

    return JSON.parse(companyLicenseInformation);
  }

  public setCompanyType(companyType: CompanyType) {
    this.controller.view.dom.$licenseMainForm?.setCompanyType(companyType);
  }

  public resetPrepaidSubform() {
    this.controller.view.dom.$licenseMainForm?.resetPrepaidSubform();
  }
}
